import { EShopCategory } from '@r1-frontend/api-domru/api-content/v1/shop/items/requestDto';
import { IEquipment } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/Equipment.dto';
import { IEquipmentCategory } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/EquipmentCategory.dto';

import { NBSP } from '@r1-frontend/ui-react/tokens/symbols';

interface IParams {
    title: IEquipment['title'],
    categoryName?: IEquipmentCategory['name'],
}

export const getDetailsByEquipmentCategory = ({ title, categoryName = '' }: IParams) => {
    switch (categoryName) {
        case EShopCategory.Decoders:
            return {
                image: {
                    url: require('~/static/images/equipment/test-drive/movix.png'),
                    urlWebp: require('~/static/images/equipment/test-drive/movix.webp'),
                    alt: 'Изображение пульта приставки Movix',
                },
                description: `Возьмите ТВ-приставку ${title} в${NBSP}тест-драйв, чтобы оценить все её${NBSP}возможности.`,
            };
        case EShopCategory.YandexStation:
        case EShopCategory.YandexStationLite:
            return {
                image: {
                    url: require('~/static/images/equipment/test-drive/yandex-station.png'),
                    urlWebp: require('~/static/images/equipment/test-drive/yandex-station.webp'),
                    alt: 'Изображение Яндекс.Станции',
                },
                description: `Возьмите умную колонку ${title} в${NBSP}тест-драйв, чтобы оценить все её${NBSP}возможности.`,
            };
        case EShopCategory.Routers:
        default:
            return {
                image: {
                    url: require('~/static/images/equipment/test-drive/router.png'),
                    urlWebp: require('~/static/images/equipment/test-drive/router.webp'),
                    alt: 'Изображение роутера',
                },
                description: `Возьмите роутер ${title} в${NBSP}тест-драйв, чтобы оценить все его${NBSP}возможности.`,
            };
    }
};
